module.exports = __webpack_public_path__ + "img/tower_dome.6477bf56.svg";